import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstNItems',
    standalone: false
})
export class FirstNItemsPipe implements PipeTransform {
    transform(array: string[] | null | undefined, n: number, isToAddEllipsis?: boolean): string[] {
        if (!Array.isArray(array) || array.length === 0 || n < 0) {
            return [];
        }
        if (isToAddEllipsis && array.length > n) {
            array = array.slice(0, n);
            array.push('...');
            return array;
        }
        return array.slice(0, n);
    }
}
